/*@ngInject*/
const ServerDisconnectedModalController = function ($rootScope, $scope, $interval, $window, $state, options, coreConstant, logUtil, refreshLoginTokenUtil, coreMediator) {

    let intervalObject = null;

    $scope.viewModel = {
        title: options.title,
        summary: options.summary,
        showAdditionalSummary: false,
        additionalSummary: options.additionalSummary
    };

    function init() {
        let reconnectTryCount = 0,
            unixMilliSecondsWhenDisconnected = moment().valueOf();

        $rootScope.$broadcast(coreConstant.event.STOP_KEEPALIVE_PING);
        refreshLoginTokenUtil.stop();
        $rootScope.$broadcast(coreConstant.event.STOP_IDLE);

        intervalObject = $interval(function () {
            function onSuccess() {
                let disconnectedForMillis = moment().valueOf() - unixMilliSecondsWhenDisconnected;
                logUtil.logWarning('Client Reconnect: disconnectedForMillis: ' + disconnectedForMillis).then(function () {
                    $window.location.reload();
                });
            }

            function onError() {
                if (reconnectTryCount >= coreConstant.SERVER_DISCONNECTED_TRIES_BEFORE_ADDITIONAL_INFO) {
                    $scope.viewModel.showAdditionalSummary = true;
                }
            }

            if (_.indexOf($state.current.name, 'login') === -1) {
                reconnectTryCount++;
                coreMediator.ack().then(onSuccess, onError);
            }
        }, coreConstant.DEFAULT_SERVER_DISCONNECTED_RECONNECT_INTERVAL);
    }

    $scope.$on('$destroy', function () {
        $interval.cancel(intervalObject);
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('umCore')
    .controller('serverDisconnectedModalController', ServerDisconnectedModalController);
